function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split("&")
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=")
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * {"appId":null,"platform":"android/ios","version":"1.0.0"}
 */
let initResolve = null
let initPromise = new Promise(resolve => (initResolve = resolve))
window.qd__fromApp = false
let payload = getQueryVariable("QD_APP")
if (payload) {
  try {
    payload = JSON.parse(decodeURIComponent(payload))
    window.qd__appPayload = payload
    window.qd__init = token => initResolve(token)
    window.qd__fromApp = true
    // eslint-disable-next-line no-empty
  } catch (e) {}
} else {
  initResolve()
}

export default initPromise
